/* Utils */
import { FORGE_ROCK_PROVIDER } from '../utils';
import createRenewCredentialsOnlySessionToken from './createRenewCredentialsOnlySessionToken';
import { createDeferredPromise, isAccessTokenExpired } from './utils';

/**
 * @returns {import('../createService').RenewCredentialsCreator}
 */
export default function createRenewCredentialsFull({
  onFailed, deviceId, getUserProfile, forgeRockService, forgeRockScope,
}) {
  let deferredRenew;
  const renewCredentialsOnlySessionTokenCreator = createRenewCredentialsOnlySessionToken(
    () => {},
  );

  return (backendService) => {
    const renewCredentialsOnlySessionToken = renewCredentialsOnlySessionTokenCreator(
      backendService,
    );

    return async (currentCredentials, shouldRenewArg) => {
      const shouldRenew = { ...shouldRenewArg };
      let newCredentials = currentCredentials;
      if (deferredRenew) {
        const {
          promise,
          data: {
            sessionToken: renewingSessionToken,
            accessToken: renewingAccessToken,
          },
        } = deferredRenew;
        if (
          ((shouldRenew.sessionToken && renewingSessionToken) || !shouldRenew.sessionToken)
          && ((shouldRenew.accessToken && renewingAccessToken) || !shouldRenew.accessToken)
        ) {
          return promise;
        }

        deferredRenew = createDeferredPromise(shouldRenew);
        newCredentials = await promise;
      } else {
        deferredRenew = createDeferredPromise(shouldRenew);
      }

      try {
        if (shouldRenew.sessionToken) {
          const savedCredentials = newCredentials;
          newCredentials = await renewCredentialsOnlySessionToken(
            newCredentials,
            shouldRenew,
          );
          if (newCredentials !== savedCredentials) {
            shouldRenew.accessToken = true;
            deferredRenew.data.accessToken = true;
          }
        }

        const { accessTokenData, sessionTokenData } = newCredentials;

        if (accessTokenData && shouldRenew.accessToken && isAccessTokenExpired(accessTokenData)) {
          deferredRenew.data.sessionToken = true;

          const { refreshToken } = accessTokenData;
          const { userName, profile: { email } = {} } = getUserProfile();
          const responseForgerock = await forgeRockService.login.renewToken({
            username: userName || email,
            refresh_token: refreshToken,
            scope: forgeRockScope,
          });
          const {
            id_token: idToken,
            access_token: accessToken,
            refresh_token: newRefreshToken,
            expires_in: expiresIn,
          } = responseForgerock.data;

          const timestamp = Math.floor(Date.now() / 1000) * 1000;
          const expireDate = timestamp + expiresIn * 1000;

          const response = await backendService.subscriber.loginFederated({
            accessToken: idToken,
            provider: FORGE_ROCK_PROVIDER,
            deviceID: deviceId,
          });

          const { sessionToken } = response.data;

          newCredentials = {
            ...newCredentials,
            accessTokenData: {
              ...accessTokenData,
              idToken,
              accessToken,
              refreshToken: newRefreshToken,
              expiresIn,
              timestamp,
              expireDate,
            },
            sessionTokenData: {
              ...sessionTokenData,
              sessionToken,
            },
          };
        }

        deferredRenew.resolve(newCredentials);
        deferredRenew = undefined;

        return newCredentials;
      } catch (error) {
        console.error('renewCredentialsFull error:', error);
        deferredRenew.reject(error);
        deferredRenew = undefined;
        onFailed(error);
        throw error;
      }
    };
  };
}
